import { push } from '@lagunovsky/redux-react-router'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import config from 'config/index'
import './FormGoPay.scss'
import hocConnect from './hocConnect'

const FormGoPay = ({ actionUrl, open }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    if (!open) return null

    if (_.isEmpty(actionUrl)) {
        console.error('FormGoPay - No action URL!')
        dispatch(push('/error'))
        return null
    }

    return (
        <div className={'form-wrapper'}>
            <div className="form-overlay"></div>
            <form action={actionUrl} method="post" id="frmPayment">
                <button
                    id="btPaymentSubmit"
                    name="pay"
                    className="btn PaymentGateRedirectJS isPaymentButtonJS"
                    type="submit"
                >
                    {'Zaplatit'}
                </button>
                <script type="text/javascript" src={config.gopay.goPayApiEmbedUrl}></script>
            </form>
        </div>
    )
}

export default hocConnect(FormGoPay)
